{
  "status": {
    "pending": "대기 중",
    "preliminary": "잠정 보고",
    "final": "최종 보고",
    "corrected": "정정 보고",
    "amended": "추가 보고",
    "addended": "추기 있음",
    "enteredInError": "입력 오류",
    "unknown": "알 수 없음"
  },
  "review": {
    "title": "결과 확인",
    "printLabel": "결과 인쇄",
    "summary": {
      "count_one": "결과 {{count}}건",
      "count_other": "결과 {{count}}건",
      "criticalUnacknowledged": "미확인 위험 수치 {{count}}건"
    },
    "view": {
      "timeline": "타임라인",
      "flowsheet": "흐름표"
    },
    "filter": {
      "date": "날짜",
      "type": "유형",
      "status": "상태",
      "statusAll": "전체"
    },
    "dateRange": {
      "h24": "최근 24시간",
      "h48": "최근 48시간",
      "d7": "최근 7일",
      "d30": "최근 30일",
      "all": "전체"
    },
    "resultType": {
      "all": "전체",
      "lab": "검사",
      "imaging": "영상",
      "pathology": "병리",
      "cardiology": "심장",
      "microbiology": "미생물"
    },
    "criticalOnlyToggle": "위험 수치만 표시",
    "criticalBadge": "위험",
    "actions": {
      "acknowledgeCritical": "위험 수치 확인",
      "acknowledgeAllCritical": "긴급 결과 모두 확인 ({{count}})"
    },
    "detail": {
      "resultNumber": "결과 번호",
      "performingProviderId": "수행 의사 ID",
      "verifiedByProviderId": "확인 의사 ID",
      "verifiedAt": "확인 시각",
      "specimenCollected": "검체 채취 시각",
      "clinicalSignificance": "임상적 의의",
      "recommendations": "권고 사항",
      "report": "보고서",
      "addendum": "추록",
      "criticalAcknowledged": "위험 수치 확인됨",
      "providerHash": "의사 #{{id}}",
      "acknowledgedAt": " 시각 {{when}}",
      "specimenType": "검체 종류",
      "grossDescription": "육안 소견",
      "microscopicDescription": "현미경 소견",
      "accessionNumber": "접수번호",
      "bodyRegion": "검사 부위",
      "studyInstanceUid": "검사 인스턴스 UID",
      "cardiologyMeasurements": "측정값",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "결과를 불러오는 중…",
    "loadError": "결과를 불러오지 못했습니다. 다시 시도해 주십시오.",
    "empty": "선택한 조건에 해당하는 결과가 없습니다.",
    "toast": {
      "acknowledgeSuccess": "위험 수치를 확인했습니다",
      "acknowledgeError": "결과 확인에 실패했습니다"
    },
    "susceptibility": {
      "title": "균종 및 감수성",
      "antibiotic": "항생제",
      "interpretation": "판정",
      "mic": "MIC",
      "unnamedOrganism": "균명 미상",
      "noPanel": "이 균에 대한 감수성 결과가 보고되지 않았습니다."
    },
    "components": {
      "value": "결과값",
      "referenceRange": "참고 범위"
    }
  },
  "pending": {
    "title": "대기 중인 결과",
    "countBadge_one": "대기 {{count}}건",
    "countBadge_other": "대기 {{count}}건",
    "autoRefresh": "자동 새로고침 {{seconds}}초",
    "updated": "업데이트 {{when}}",
    "searchPlaceholder": "환자명, MRN, 처방으로 검색…",
    "filtersButton": "필터",
    "fields": {
      "orderType": "처방 유형",
      "allTypes": "전체 유형",
      "priority": "우선순위",
      "allPriorities": "전체 우선순위",
      "dateFrom": "시작일",
      "dateTo": "종료일"
    },
    "orderType": {
      "lab": "검사",
      "imaging": "영상",
      "procedure": "시술",
      "consultation": "협진",
      "laboratory": "임상검사",
      "radiology": "방사선",
      "surgery": "수술",
      "therapy": "치료",
      "medication": "투약",
      "admission": "입원"
    },
    "aria": {
      "dateFrom": "대기 결과 시작일",
      "dateTo": "대기 결과 종료일"
    },
    "columns": {
      "patient": "환자",
      "mrn": "MRN",
      "order": "처방",
      "type": "유형",
      "orderedBy": "처방의",
      "ordered": "처방 시각",
      "expected": "예정 시각",
      "priority": "우선순위"
    },
    "loading": "대기 중인 결과를 불러오는 중…",
    "loadError": "대기 결과를 불러오지 못했습니다",
    "retry": "다시 시도",
    "empty": "대기 중인 결과가 없습니다.",
    "awaitingResult": "결과 대기",
    "specimenReceived": "검체 접수",
    "inLab": "검사실 진행 중",
    "cancelledByLab": "검사실 취소",
    "overdue": "지연",
    "expectedBy": "{{date}}까지 예정"
  },
  "critical": {
    "title": "위험 결과",
    "autoRefresh": "자동 새로고침 {{seconds}}초",
    "updated": "업데이트 {{when}}",
    "unacknowledgedHeading_one": "미확인 위험 수치 {{count}}건",
    "unacknowledgedHeading_other": "미확인 위험 수치 {{count}}건",
    "escalationBanner": "위 결과는 의사의 즉각적인 확인이 필요합니다.",
    "acknowledgeWithinMinutes": "{{minutes}}분 이내 확인",
    "routeBackToProvider": "처방의에게 회신",
    "attendingSignoff": "주치의 서명 필요",
    "searchPlaceholder": "환자·검사명으로 검색…",
    "showAcknowledgedToggle": "확인됨 표시",
    "escalationTime": "T+{{minutes}}분",
    "criticalFallback": "위험",
    "loading": "위험 결과를 불러오는 중…",
    "loadError": "위험 결과를 불러오지 못했습니다",
    "empty": "확인 대기 중인 위험 결과가 없습니다.",
    "detailToggleLabel": "결과 세부정보 표시",
    "openFullChart": "전체 차트 열기",
    "columns": {
      "patient": "환자",
      "mrn": "MRN",
      "test": "검사",
      "value": "값",
      "impression": "소견",
      "resultTime": "결과 시각",
      "escalation": "경과 시간",
      "acknowledged": "확인",
      "actions": "조치"
    },
    "actions": {
      "acknowledge": "확인"
    },
    "toast": {
      "acknowledgeSuccess": "위험 수치를 확인했습니다",
      "acknowledgeError": "결과 확인에 실패했습니다"
    },
    "refreshFailed": "새로 고칠 수 없습니다 — {{when}} 기준의 위험 결과를 표시합니다.",
    "incomplete": "위험 결과 {{total}}건 중 {{shown}}건만 표시합니다. 이 목록은 불완전합니다."
  },
  "acknowledged": {
    "pending": "확인 대기",
    "acknowledged": "확인됨",
    "escalated": "에스컬레이션됨",
    "expired": "확인 기한 경과"
  },
  "flowsheet": {
    "analyte": "검사 항목",
    "empty": "추세를 표시할 검사 항목이 없습니다",
    "emptyHint": "영상, 병리, 미생물 보고서는 타임라인 보기에 있습니다.",
    "trend": {
      "toggle": "{{analyte}} 추이",
      "referenceRange": "참고치 {{range}}",
      "nonNumericOmitted_one": "텍스트 결과 {{count}}건은 표시되지 않음",
      "nonNumericOmitted_other": "텍스트 결과 {{count}}건은 표시되지 않음"
    }
  }
}
